'use client'

import { isNull } from 'lodash-es'
import { useRouter } from 'next/navigation'

import { useSession } from '@/shared/lib'
import { Button } from '@/shared/ui'

import {
  getRequestContractUrl,
  useContract,
} from './contract-information/provider'
import { DIALOG } from '../../lib/contract-dialog'

type Props = {
  roomId: number
  disabled?: boolean
}

export const ContractButton = ({ roomId, disabled = false }: Props) => {
  const router = useRouter()
  const session = useSession()

  const { period, hasPeriodSelected, openDialog, getLastActiveContract } =
    useContract()

  const handleClick = async () => {
    const isBlockedUser = session?.data?.blocked

    if (isBlockedUser) {
      openDialog(DIALOG.BLOCKED_USER)

      return
    }

    const { success, data: contract } = await getLastActiveContract()

    if (!success) {
      return
    }

    // 진행 중인 계약이 없는 경우 & 기간이 선택되지 않은 경우
    if (isNull(contract) && !hasPeriodSelected) {
      openDialog(DIALOG.PERIOD_CALENDAR)

      return
    }

    // 진행 중인 계약이 없는 경우 & 기간이 선택된 경우
    if (isNull(contract) && hasPeriodSelected) {
      router.push(
        getRequestContractUrl({
          roomId,
          dateRange: { from: period?.from, to: period?.to },
        }),
      )

      return
    }

    if (contract?.isExtendContractAvailable) {
      // 확정된 계약이 있는 경우 (연장 가능한 경우)
      openDialog(DIALOG.CHECK_EXTEND_CONTRACT)
    } else {
      // 계약 대기 상태의 계약이 있는 경우
      openDialog(DIALOG.IN_PROGRESS_CONTRACT)
    }
  }

  return (
    <div className="px-6">
      <Button size="large" fullWidth onClick={handleClick} disabled={disabled}>
        계약 시작하기
      </Button>
    </div>
  )
}
